import { BuildingOfficeIcon, UserIcon, UsersIcon } from "@heroicons/react/24/outline";
import { HandshakeIcon } from "components/ui/handshake-icon";
import { AdvancedSearchEntityType } from "generated/graphql";
import React from "react";

interface EntityTypeIconProps {
    attachTo: AdvancedSearchEntityType;
    className: string;
}

export const EntityTypeIcon: React.FC<EntityTypeIconProps> = props => {
    const { attachTo, className } = props;
    switch (attachTo) {
        case AdvancedSearchEntityType.HomeCareLead:
            return <UserIcon className={className} />;
        case AdvancedSearchEntityType.ReferenceContact:
            return <HandshakeIcon className={className} />;
        case AdvancedSearchEntityType.ReferenceBusiness:
            return <BuildingOfficeIcon className={className} />;
        default:
            return <UsersIcon className={className} />;
    }
};
